import { TASKS_SERVICE_URL } from "@coworker/app/src/hooks/API/tasks.service.helper";
import {
  createAuthorizationHeader,
  toJson,
} from "@coworker/apprestructured/src/task-management/services/fetchHelper";
import { GroupedSalesLocations } from "@coworker/apprestructured/src/task-management/types/SalesLocation";

const BASE_URL = `${TASKS_SERVICE_URL}/v1/locations`;

export async function getLocations(itemNo: string, type: string) {
  const params = new URLSearchParams({ itemNo, type });
  return toJson<GroupedSalesLocations>(
    await fetch(`${BASE_URL}?${params.toString()}`, {
      method: "GET",
      headers: {
        ...(await createAuthorizationHeader()),
        "Content-Type": "application/json",
      },
    })
  );
}
